module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ActivityCenterView.js"));
	}, "ActivityCenterView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ActivityCenterView!./src/pages/Promote/OfflineActivity/ActivityCenter/ActivityCenterView.js
// module id = 2099
// module chunks = 367